module.exports = __webpack_public_path__ + "img/i02_.485cd4bc.svg";